import { Sparkles } from "lucide-react";
import Markdown from "react-markdown";
import { cn } from "../../lib/utils";
import { i18n } from "@tellescope/i18n";

export interface AISummaryProps {
  title?: string;
  content: string;
  className?: string;
}

export function AISummary({ title = i18n.t("AI Summary", { ns: "ai" }), content, className = "" }: AISummaryProps) {
  return (
    <div
      className={cn("bg-gradient-to-r from-purple-50 to-gray-50 border border-purple-200 rounded-lg p-4", className)}
    >
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-medium text-purple-900">{title}</span>
        <Sparkles className="h-4 w-4 text-purple-600" />
      </div>
      <div className="text-sm text-gray-800 prose prose-sm prose-gray max-w-none [&>p]:mb-1.5 [&>p:last-child]:mb-0 [&>ul]:mt-1 [&>ul]:mb-0 [&>ul]:pl-5 [&>ul]:space-y-0 [&>ol]:mt-1 [&>ol]:mb-0 [&>ol]:pl-5 [&>ol]:space-y-0 [&_li]:mb-0 [&_li]:leading-snug [&_li]:pl-1">
        <Markdown>{content}</Markdown>
      </div>
    </div>
  );
}
